export const ELEMENT_SIZE_SETTING_KEY = 'element_size'
export const MIN_RESOLUTION_SETTING_KEY = 'min_resolution'

export type ElementSize = {
  text: number
  graphic: number
  ai_image: number
  monogram: number
  upload_graphic: number
}

export type MinimumResolution = {
  width: number
  height: number
}

export type CustomizationElementSettingsFormValues = {
  textElementSize: number | string
  graphicElementSize: number | string
  aiImageElementSize: number | string
  monogramElementSize: number | string
  uploadGraphicElementSize: number | string
  minimumResolutionWidth: number | string
  minimumResolutionHeight: number | string
}

export type CustomizationElementSettingsPayload = {
  elementSize: ElementSize
  minimumResolution: MinimumResolution
}
